"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const use_field_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-field-api"));
const TreeView_1 = __importDefault(require("../../../TreeView"));
const FormField_1 = __importDefault(require("../../../FormField"));
const useUniqueId_1 = __importDefault(require("../../../../hooks/useUniqueId"));
const getErrorText_1 = require("../../utils/getErrorText");
const TreeViewMapping = (props) => {
    const { label, description, helperText, isReadOnly, input, validateOnMount, stretch, showError, meta: { error, submitFailed }, multiSelect, // from TreeView
    treeItems, // from TreeView
    onNodeToggle, // from TreeView
    defaultExpanded, // from TreeView
     } = use_field_api_1.default(props);
    const controlId = useUniqueId_1.default(input.name);
    const errorText = getErrorText_1.getErrorText(validateOnMount, submitFailed, showError, error);
    input.readOnly = isReadOnly;
    return (react_1.default.createElement(FormField_1.default, { controlId: controlId, label: label, description: description, hintText: helperText, errorText: errorText, stretch: stretch },
        react_1.default.createElement(TreeView_1.default, { root: treeItems, multiSelect: multiSelect, defaultSelected: input.value || [], defaultExpanded: defaultExpanded, onNodeSelect: (_, nodeIds) => input.onChange(nodeIds || []), onNodeToggle: onNodeToggle })));
};
exports.default = TreeViewMapping;
//# sourceMappingURL=index.js.map